export const defaultSeoSettings = {
  additionalMetaTags: [
    {
      name: "charset",
      content: "utf-8",
    },
    {
      name: "viewport",
      content: "initial-scale=1.0, width=device-width",
    },
    {
      name: "msapplication-TileColor",
      content: "#fdfdfd",
    },
    {
      name: "theme-color",
      content: "#fdfdfd",
    },
  ],
  titleTemplate: `%s | ${process.env.NEXT_PUBLIC_SITE_NAME}`,
  defaultTitle: process.env.NEXT_PUBLIC_SITE_NAME,
  description: `${process.env.NEXT_PUBLIC_SITE_NAME}は、音楽に関する情報や知識、経験や知見を共有するサービスです。誰でも読めて誰でも書くことができます`,
  canonical: process.env.NEXT_PUBLIC_WEB_URL,
  openGraph: {
    type: "website",
    locale: "ja",
    url: process.env.NEXT_PUBLIC_WEB_URL,
    site_name: process.env.NEXT_PUBLIC_SITE_NAME,
  },
  twitter: {
    site: process.env.NEXT_PUBLIC_WEB_URL,
    cardType: "summary_large_image",
  },
};
